import React, { useState, useRef } from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Column } from 'primereact/column';

import LoadingScreen from 'src/components/LoadingScreen';

import { ModelOfUser } from 'src/database';

import useIntersectionObserver from 'src/components/IntersectionObserver/useIntersectionObserver';
import { useListUserController } from 'src/controllers/User/ListUserController';
import { Toast } from 'primereact/toast';
import { PulseLoader } from 'react-spinners';

const UserList: React.FC = () => {
	const { getUserListController, handleUserListController } = useListUserController();

	const [globalFilter, setGlobalFilter] = useState<string | null>(null);

	const Loader: React.FC = ({ children }) => {
		const divRef: any = useRef<HTMLDivElement | null>(null);

		const [isVisible] = useIntersectionObserver({
			elementRef: divRef,
		});

		if (isVisible && !getUserListController.maxData && !getUserListController.loadingRows) {
			handleUserListController.setRows(getUserListController.rows + 20);
		}

		return (
			<div
				ref={divRef}
				style={{
					height: 'auto',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}>
				{children}
			</div>
		);
	};

	if (getUserListController.loading) {
		return <LoadingScreen />;
	}

	const editUserDialogFooter = (
		<React.Fragment>
			<Button
				label='Cancelar'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleUserListController.closeEditDialog}
			/>
			<Button
				type='submit'
				label='Salvar'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					handleUserListController.formik.handleSubmit();
				}}
			/>
		</React.Fragment>
	);

	const actionBodyTemplate = (User: ModelOfUser) => {
		return (
			<React.Fragment>
				<Button
					icon='pi pi-search'
					className='p-button-rounded p-button-text p-button-success'
					onClick={() => handleUserListController.showPassword(User)}
				/>
				<Button
					icon='pi pi-pencil'
					className='p-button-rounded p-button-text p-button-success'
					onClick={() => handleUserListController.openEditDialog(User)}
				/>
				<Button
					icon='pi pi-trash'
					className='p-button-rounded p-button-text p-button-danger'
					onClick={() => handleUserListController.openDeleteDialog(User)}
				/>
			</React.Fragment>
		);
	};

	const deleteUserDialogFooter = (
		<React.Fragment>
			<Button
				label='Não'
				icon='pi pi-times'
				className='p-button-text'
				onClick={handleUserListController.closeDeleteDialog}
			/>
			<Button
				label='Sim'
				icon='pi pi-check'
				className='p-button-text'
				onClick={() => {
					getUserListController.selectedUser &&
						handleUserListController.removeUser(getUserListController.selectedUser);
				}}
			/>
		</React.Fragment>
	);

	const tableHeader = (
		<div className='table-header p-grid p-d-flex p-jc-between'>
			<h5 className='p-m-0'>Usuários</h5>
			<span className='p-input-icon-left p-search-bar'>
				<i className='pi pi-search' />
				<InputText
					type='search'
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)}
					placeholder='Buscar...'
				/>
			</span>
		</div>
	);

	const HEADER_NOME = (rowData: ModelOfUser) => {
		return (
			<React.Fragment>
				<span className='left-header'>NOME</span>
				{rowData.NOME}
			</React.Fragment>
		);
	};

	const HEADER_EMAIL = (rowData: ModelOfUser) => {
		return (
			<React.Fragment>
				<span className='left-header'>EMAIL</span>
				{rowData.LOGIN}
			</React.Fragment>
		);
	};

	const leftUserToolbar = () => {
		return (
			<Link to='/userForm'>
				<Button label='Cadastrar Usuarios' icon='pi pi-plus' className='p-button-success p-mr-2' />
			</Link>
		);
	};

	return (
		<div className='p-card p-p-4 datatable-container'>
			<Toast ref={getUserListController.toast} />
			<Toolbar className='p-mb-4' left={leftUserToolbar}></Toolbar>
			<DataTable
				header={tableHeader}
				globalFilter={globalFilter}
				className='responsive-table p-datatable-sm'
				dataKey='ID'
				autoLayout
				rowHover
				scrollable
				scrollHeight='100%'
				value={getUserListController.AllUserData}>
				<Column field='NOME' header='NOME' body={HEADER_NOME}></Column>
				<Column field='EMAIL' header='EMAIL' body={HEADER_EMAIL}></Column>
				<Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
			</DataTable>
			{/* <Loader>
				{!getUserListController.maxData ? (
					getUserListController.loadingRows ? (
						<PulseLoader color='#0388e5' size={8} />
					) : (
						<></>
					)
				) : (
					'Lista completa'
				)}
			</Loader> */}

			<Dialog
				className='p-fluid'
				style={{ width: '90%' }}
				visible={getUserListController.editDialog}
				onHide={handleUserListController.closeEditDialog}
				onShow={() => getUserListController.formik.setValues(getUserListController.selectedUser)}
				footer={editUserDialogFooter}
				header={`Editar usuário ${getUserListController.selectedUser?.NOME}`}
				modal>
				{getUserListController.loadingEdit ? <LoadingScreen color='#0388e5' /> : <></>}
				<div className='p-grid p-fluid'>
					<div className='p-field p-col-12'>
						{/* <img style={{height:50, width:50}} src="http://www.icontroler.com.br/controleinternoimagem/01558070000122/docveiculo/ba9df08b-dc25-4fa2-aa9b-40884bbe5efd.jpeg"/> */}
						<label htmlFor='nome'>Nome</label>
						<InputText
							id='nome'
							maxLength={150}
							disabled={true}
							{...getUserListController.formik.getFieldProps('NOME')}
							onChange={getUserListController.formik.handleChange('NOME')}
						/>
					</div>

					<div className='p-field p-col-12 p-md-9'>
						<label htmlFor='login'>Login</label>
						<InputText
							id='login'
							maxLength={150}
							{...getUserListController.formik.getFieldProps('LOGIN')}
							onChange={getUserListController.formik.handleChange('LOGIN')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getUserListController.formik.touched.LOGIN &&
									getUserListController.formik.errors.LOGIN,
								'popup-form-inactive': !(
									getUserListController.formik.touched.LOGIN &&
									getUserListController.formik.errors.LOGIN
								),
							})}>
							{getUserListController.formik.errors.LOGIN}
						</div>
					</div>
				</div>
			</Dialog>

			<Dialog
				className='p-fluid'
				style={{ width: '90%' }}
				visible={getUserListController.passwordDialog}
				onHide={handleUserListController.closePasswordDialog}
				onShow={() => getUserListController.formik.setValues(getUserListController.selectedUser)}
				header={`${getUserListController.selectedUser?.NOME}`}
				modal
				dismissableMask>
				<div className='p-grid p-fluid'>
					<div className='p-field p-col-12'>
						<label htmlFor='senha'>
							<strong>Senha:</strong> {getUserListController.selectedUser?.SENHA}
						</label>
					</div>
				</div>
			</Dialog>

			<Dialog
				style={{ width: '450px' }}
				visible={getUserListController.deleteDialog}
				onHide={handleUserListController.closeDeleteDialog}
				footer={deleteUserDialogFooter}
				header='Remover usuário'
				modal>
				<div className='confirmation-content'>
					<i className='pi pi-exclamation-triangle p-mr-3' style={{ fontSize: '2rem' }} />
					{getUserListController.selectedUser && (
						<span>
							Você tem certeza que deseja remover <b>{getUserListController.selectedUser.NOME}</b>?
						</span>
					)}
				</div>
			</Dialog>
		</div>
	);
};

export default UserList;
